module.exports = __webpack_public_path__ + "img/process-recommendation.e0e9cda8.png";